<template>
  <div>
    <q-dialog v-model="show" @input="(val) => $emit('input', val)">
      <q-layout view="Lhh lpR fff" container class="tw-bg-white modal-medium">
        <q-header style="background-color:#3a4155">
          <q-toolbar>
            <q-toolbar-title>
              {{$gettext('VIEW_SERVICE_REQUEST_PROTOCOL')}} {{serviceRequest.protocol}}
            </q-toolbar-title>
            <q-btn id="close-button" v-close-popup flat round dense icon="close" />
          </q-toolbar>
        </q-header>
        <q-page-container class="container-main">
          <q-page-containe class="container-one">
            <div class="left card">
              <div class="title-card">
                <q-icon name="history" size="30px" />
                {{ $gettext("SERVICE_REQUEST_DATA") }}
              </div>
              <div class="detail-registry">
                <div class="detail-left">
                  <div class="row-detail">
                    <span class="text-subtitle2 bg-ice box-label">
                      {{ $gettext("START_SERVICE_REQUEST") }}:
                      <span class="text-subtitle1">{{serviceRequest.startDate}}</span>
                    </span>
                  </div>
                  <div class="row-detail">
                    <span class="text-subtitle2 box-label">
                      {{ $gettext("CUSTOMER") }}:
                      <span class="text-subtitle1">{{serviceRequest.client}}</span>
                    </span>
                  </div>
                  <div class="row-detail">
                    <span class="text-subtitle2 bg-ice box-label">
                      {{ $gettext("SERVICE_REQUEST_TIPE") }}:
                      <span class="text-subtitle1">{{serviceRequest.type}}</span>
                    </span>
                  </div>
                  <div class="row-detail">
                    <span class="text-subtitle2 box-label">
                      {{ $gettext("ATTENDANT") }}:
                      <span class="text-subtitle1">{{serviceRequest.attendant}}</span>
                    </span>
                  </div>
                  <div class="row-detail observation">
                    <span class="text-subtitle2 bg-ice box-label">
                      {{ $gettext("OBSERVATION") }}:
                      <span class="text-subtitle1">----------</span>
                    </span>
                  </div>
                </div>
                <div class="detail-rigth">
                  <div class="row-detail">
                    <span class="text-subtitle2 bg-ice box-label">
                      {{ $gettext("END_SERVICE_REQUEST") }}:
                      <span class="text-subtitle1">{{serviceRequest.endDate}}</span>
                    </span>
                  </div>
                  <div class="row-detail">
                    <span class="text-subtitle2 box-label">
                      {{ $gettext("EMAIL") }}:
                      <span class="text-subtitle1">{{serviceRequest.email}}</span>
                    </span>
                  </div>
                  <div class="row-detail">
                    <span class="text-subtitle2 bg-ice box-label">
                      {{ $gettext("PHONE") }}:
                      <span class="text-subtitle1">----------</span>
                    </span>
                  </div>
                  <div class="row-detail">
                    <span class="text-subtitle2 box-label is-check-label">
                      {{ $gettext("PRINTED") }}:
                      <span class="text-subtitle1" v-if="true">
                        <q-icon
                          name="mdi-check-circle"
                          size="17px"
                          class="icon-position icon-yes"
                        />
                        {{ $gettext("YES") }}
                      </span>
                      <span class="text-subtitle1" v-else>
                        <q-icon
                          name="mdi-close-circle"
                          size="17px"
                          class="icon-position icon-no"
                        />
                        {{ $gettext("NO") }}
                      </span>
                    </span>
                  </div>
                  <div class="row-detail">
                    <span
                      class="text-subtitle2 bg-ice box-label is-check-label"
                    >
                      {{ $gettext("IS_SEND_EMAIL") }}:
                      <span class="text-subtitle1" v-if="false">
                        <q-icon
                          name="mdi-check-circle"
                          size="17px"
                          class="icon-position icon-yes"
                        />
                        {{ $gettext("YES") }}
                      </span>
                      <span class="text-subtitle1" v-else>
                        <q-icon
                          name="mdi-close-circle"
                          size="17px"
                          class="icon-position icon-no"
                        />
                        {{ $gettext("NO") }}
                      </span>
                    </span>
                  </div>
                  <div class="row-detail">
                    <span class="text-subtitle2 box-label is-check-label">
                      {{ $gettext("IS_SEND_SMS") }}:
                      <span class="text-subtitle1" v-if="false">
                        <q-icon
                          name="mdi-check-circle"
                          size="17px"
                          class="icon-position icon-yes"
                        />
                        {{ $gettext("YES") }}
                      </span>
                      <span class="text-subtitle1" v-else>
                        <q-icon
                          name="mdi-close-circle"
                          size="17px"
                          class="icon-position icon-no"
                        />
                        {{ $gettext("NO") }}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="top card">
                <div class="title-card">
                  {{ $gettext("OPEN_SERVICE_REQUEST_INFORMATION") }}
                </div>
                <div class="detail-registry detail-registry-column">
                  <div class="row-detail">
                    <span class="text-subtitle2 box-label">
                      <span class="text-subtitle1">{{ firstServiceObservation }}</span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="bottom card">
                <div class="title-card">
                  {{ $gettext("CLOSE_SERVICE_REQUEST_INFORMATION") }}
                </div>
                <div class="detail-registry detail-registry-column">
                  <div class="row-detail">
                    <span class="text-subtitle2 box-label">
                      <span class="text-subtitle1">{{ lastServiceObservation }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </q-page-containe>
          <div class="overflow-y-auto container-two card">
            <div class="title-card">
              <q-icon name="history" size="30px" />
              {{ $gettext("FUNCTIONALITY_ACCESSED") }}
            </div>
            <div class="p-3">
               <jt-data-table
              :api-mode="false"
              :data="dataGrid.registros"
              :fields="dataTableGrid.columns"
              :is-paginated="false"
              :title="titleTeble"
              row-buttons
              @action-button="actionButton"
            >
              <template #header="{props}">
                <q-tr :props="props" class="table-header">
                  <q-td
                    v-for="col in props.cols"
                    :key="col.name"
                    :props="props"
                  >
                    <div style="display: flex; justify-content: center">
                      {{ col.label }}
                    </div>
                  </q-td>
                  <q-td />
                </q-tr>
              </template>
            </jt-data-table>
            </div>

          </div>
          <div class="container-three card">
            <div class="title-card">
              <q-icon name="history" size="30px" />
              {{ $gettext("DATA_SEARCH_SERVICE_REQUEST") }}
            </div>
            <div>
              <div class="detail-registry">
                <div class="detail-left">
                  <div class="row-detail">
                    <span class="text-subtitle2 bg-ice box-label">
                      {{ $gettext("SEARCH") }}:
                      <span class="text-subtitle1">----</span>
                    </span>
                  </div>
                  <div class="row-detail">
                    <span class="text-subtitle2 box-label">
                      {{ $gettext("SITUATION") }}:
                      <span class="text-subtitle1">----</span>
                    </span>
                  </div>
                </div>
                <div class="detail-rigth">
                  <div class="row-detail">
                    <span class="text-subtitle2 bg-ice box-label">
                      {{ $gettext("SEARCH_DATE") }}:
                      <span class="text-subtitle1">----</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </q-page-container>
      </q-layout>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
const { pageDetail, page } = JtCrud
import { QDialog, Dialog } from 'quasar'
import ServiceRequestListController from './ServiceRequestListController'
import ServiceObservationController from '../../registration-information/service-observation/ServiceObservationController'
import moment from 'moment'

@Component({
  mixins: [page],
  name: 'ServiceRequestDetailModal',
  components: {
    page,
    pageDetail,
    QDialog,
    Dialog
  },
  props: {
    label: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object,
    serviceRequest: Object,
    show: {
      type: Boolean,
      default: false
    },
    itemsLateGroup: {
      type: Array,
      default: []
    }
  }
})
class ServiceRequestDetailModal extends Vue {
  controllerRequest = ServiceRequestListController.getInstance();
  controllerObservation = ServiceObservationController.getInstance();
  modalData = {};
  moment = moment;
  observationsData = [];
  data = []
  datatable = {}

  get firstServiceObservation () {
    const stg = this.observationsData.length
      ? this.observationsData[0].description : ''

    return this.handleSizeText(stg)
  }

  get lastServiceObservation () {
    const stg = this.observationsData.length
      ? this.observationsData[this.observationsData.length - 1].description : ''

    return this.handleSizeText(stg)
  }

  handleSizeText (stg) {
    return stg.length < 100 ? stg : `${stg.substring(0, 100)}...`
  }

  hide () {
    this.show = false
  }

  get dataGrid () {
    return this.data
  }

  get dataTableGrid () {
    return this.datatable
  }

  async mounted () {
    this.datatable = await this.controllerRequest.loadDatatable()
    await this.loadFiles()
    await this.loadObservation()
  }

  async loadObservation () {
    const data = await this.controllerObservation.loadDatatableModel()
    this.observationsData = data.registros
  }

  async loadFiles () {
    const data = await this.controllerRequest.loadDatatableModel({
      consumerUnit: parseInt(this.consumerUnit, 10)
    })
    this.data = data
  }
}

export default ServiceRequestDetailModal
</script>
<style lang="stylus" scoped>
.table {
  max-height: 250px;
}
.table-2 {
  max-height: 367px;
}
.icon-position {
  margin: 0px 0 0 9px;
}
.icon-no {
  color: red;
}
.icon-yes {
  color: green;
}
.is-check-label {
  display: flex;
  align-items: center;
}

.row-detail {
  display: flex;
  height: 30px;
}
.title-card {
  display: flex;
  font-size: 17px;
  height: 43px;
}
.detail-registry {
  display: flex;
  height: 85%;
  width: 100%;
  padding: 5px;
}

.detail-registry-column {
  flex-direction: column !important;
  height: 85%;
}

.detail-left {
  height: 100%;
  width: 50%;
  padding: 5px;
}
.detail-rigth {
  height: 100;
  width: 50%;
  padding: 5px;
}
.observation {
  height: 100px;
}
.box-label {
  width: 100%;
  padding-left: 10px;
  word-break: break-all;
}

.container-main  {
  padding: 20px;
  padding-top: 83px !important;

  .container-one {
    margin-bottom: 5px;
    display: flex;
    .left {
      width: 65%;
      height: 305px;
      margin-right: 5px;
    }
    .right {
      height: 300px;
      width: 35%;
      .top {
        height: 50%
        margin-bottom: 5px;
      }
      .bottom {
        height: 50%
      }
    }
  }
  .container-two {
    height: 300px;
    width: 100%;
    margin-bottom: 5px;
  }
  .container-three {
    height: 500px;
    width: 100%;
  }
}
.card {
  border-radius: 15px;
  box-shadow: 2px 2px 6px #6060608C;
  border: 0.5px solid #BCBCBC;
  border-radius: 8px;
  opacity: 1;
}
</style>
